export enum EPublishType {
  Novels = 1,
  AdNovels = 2,
  Reels = 3,
  Lists = 4,
  Community = 5,
}

export const CONTENT_ROUTE_PATH = new Map([
  [EPublishType.Novels, 'novel'],
  [EPublishType.AdNovels, 'novel'],
  [EPublishType.Reels, 'video'],
  [EPublishType.Lists, 'book'],
  [EPublishType.Community, 'discuss'],
])

export enum EConversationType {
  PRIVATE = 1,
  GROUP = 2,
}

/** 签约状态 */
export enum ENovelSignStatus {
  /** 初始状态,发起申请 */
  INITIAL = 'init',
  /** 等待状态,申请通过 */
  PENDING = 'wait',
  /** 已完成状态,已签约 */
  COMPLETED = 'done',
  /** 拒绝状态,拒绝申请 */
  REJECTED = 'reject',
  /**
   * 未签约: ''
   */
  NONE = '',
}

export enum EMessageType {
  TxtMsg = 1, // 文本
  ImgMsg = 2, // 图片
  SystemMsg = 3, // 系统消息 ?? 可能未使用
  bookMsg = 4, // 书籍分享消息
  bookListMsg = 5, // 书单分享消息
  threadListMsg = 6, // 帖子分享消息
  newSystemMsg = 7, // 新系统消息
}

export interface IMessageContentExtra {
  content: string
  extra: {
    notification_type: number
    link: string
    link_h5: string
    link_creating: string // 作者站链接
    button_name: string
    from_subsystem: string
    event: {
      name: string
      type: number
    }
  }
}

export enum BAN_TYPE_ENUM {
  BAN_LOGIN = 1,
  BAN_COMMUNITY = 2,
  BAN_IM = 3,
}
